import config from '../config';
import { authHeader } from '../helpers';

const getAllApplicant = (query) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  if (query !== undefined) {
    return fetch(
      `${config.atsApiUrl}/candidate/all?${new URLSearchParams(query)}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.atsApiUrl}/candidate/all`, requestOptions).then(
      handleResponse
    );
  }
};

const getApplicant = (id) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(
    `${config.atsApiUrl}/candidate/all?applicationId=${id}`,
    requestOptions
  ).then(handleResponse);
};

const createApplicant = (createData) => {
  const formData = new FormData();

  for (const name in createData) {
    formData.append(name, createData[name]);
  }
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(`${config.atsApiUrl}/candidate/create`, requestOptions).then(
    handleResponse
  );
};

const candidateReferral = (createData) => {
  const formData = new FormData();

  for (const name in createData) {
    formData.append(name, createData[name]);
  }
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(`${config.atsApiUrl}/candidate/referral/create`, requestOptions).then(
    handleResponse
  );
};

const createExternalApplicant = (createData) => {
  const formData = new FormData();

  for (const name in createData) {
    formData.append(name, createData[name]);
  }
  const requestOptions = {
    method: 'POST',
    body: formData,
  };

  return fetch(
    `${config.atsApiUrl}/candidate/externalApplicant`,
    requestOptions
  ).then(handleResponse);
};

const updateApplicant = (updateData, id) => {
  const formData = new FormData();
  for (const name in updateData) {
    formData.append(name, updateData[name]);
  }
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(
    `${config.atsApiUrl}/candidate/update/${id}`,
    requestOptions
  ).then(handleResponse);
};

const deleteApplicant = (id) => {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/candidate/delete/${id}`,
    requestOptions
  ).then(handleResponse);
};

/*history get*/
const applicanHistoryGet = (id) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/candidate/history/all?id=${id}`,
    requestOptions
  ).then(handleResponse);
};

const applicanCommentGet = (id) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/comment/getComment/${id}`,
    requestOptions
  ).then(handleResponse);
};

const announcementCommentGet = (id) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/comment/getFeeds/${id}`,
    requestOptions
  ).then(handleResponse);
};

const getMentaionUsers = (query) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/comment/mentionUsers?search=${query}`,
    requestOptions
  ).then(handleResponse);
};

//create comment
const createComment = (createData) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
    },
    body: createData,
  };

  return fetch(`${config.atsApiUrl}/comment/postComment`, requestOptions).then(
    handleResponse
  );
};

//create Announcement comment
const announcementCreateComment = (createData) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
    },
    body: createData,
  };

  return fetch(`${config.atsApiUrl}/comment/postFeed`, requestOptions).then(
    handleResponse
  );
};

//updateComment
const editComment = (updateData, id) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
    },
    body: updateData,
  };

  return fetch(`${config.atsApiUrl}/comment/edit/${id}`, requestOptions).then(
    handleResponse
  );
};

const deleteComment = (id) => {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/comment/delete/${id}`, requestOptions).then(
    handleResponse
  );
};

const updateCommentAccess = (req) => {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/comment/updateCommentAccess/${req.id}?isPrivate=${req.isPrivate}`, requestOptions).then(
    handleResponse
  );
};

const moveDynamicReferral = (req) => {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/candidate/move/referral/${req.id}?jobId=${req.jobId}`, requestOptions).then(
    handleResponse
  );
};

const cloneJobProfile = (req) => {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/candidate/cloneprofile/${req.id}?jobId=${req.jobId}`, requestOptions).then(
    handleResponse
  );
};

//dashboard api
const getProfileSummary = () => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(`${config.atsApiUrl}/job/profileSummary`, requestOptions).then(
    handleResponse
  );
};

const getChartSummary = (query) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  if (query) {
    return fetch(
      `${config.atsApiUrl}/candidate/summary?${query}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(
      `${config.atsApiUrl}/candidate/summary?month=12`,
      requestOptions
    ).then(handleResponse);
  }
};

//external form
const getExternalData = (id) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/job/externalData/${id}`,
    requestOptions
  ).then(handleResponse);
};

//Kanban get api
const getKanbanData = (query) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  if (query) {
    return fetch(
      `${config.atsApiUrl}/candidate/applicantsByStatus?${new URLSearchParams(
        query
      )}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(
      `${config.atsApiUrl}/candidate/applicantsByStatus`,
      requestOptions
    ).then(handleResponse);
  }
};

const updateKanbanStatus = (updateData, jobId) => {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(updateData),
  };

  return fetch(
    `${config.atsApiUrl}/job/${jobId}/applicationStatus`,
    requestOptions
  ).then(handleResponse);
};

const getApplicantStatus = (jobId) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    `${config.atsApiUrl}/job/${jobId}/applicationStatus`,
    requestOptions
  ).then(handleResponse);
};

const updateStatus = (updateData, id) => {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(updateData),
  };

  return fetch(
    `${config.atsApiUrl}/candidate/updateStatus/${id}`,
    requestOptions
  ).then(handleResponse);
};

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      if (response.status == 401) {
        localStorage.clear();
        window.location.pathname = '/';
      }
      return Promise.reject(error);
    }
    return data;
  });
};

export const applicantProfileService = {
  getAllApplicant,
  createApplicant,
  updateApplicant,
  deleteApplicant,
  applicanHistoryGet,
  applicanCommentGet,
  getMentaionUsers,
  createComment,
  getProfileSummary,
  getChartSummary,
  editComment,
  deleteComment,
  getExternalData,
  createExternalApplicant,
  getKanbanData,
  updateKanbanStatus,
  getApplicantStatus,
  getApplicant,
  updateStatus,
  announcementCreateComment,
  announcementCommentGet,
  updateCommentAccess,
  candidateReferral,
  moveDynamicReferral,
  cloneJobProfile
};
